import React from 'react';



const Header = () => {

const email = 'merlinmap502@gmail.com';

  return <header className=' py-8'>
<div className="container mx-auto">
<div className='flex justify-center items-center'>

<button className='btn btn-sm'>
        <a href={`mailto:${email}`} style={{ color: 'white', textDecoration: 'none' }}>
          WORK WITH ME
        </a>
      </button>

</div>





</div>
</header>
};


export default Header;


